import { ExitWrapper } from './style'
import { ExitToApp } from '@styled-icons/material'

export default () => {
    return (
        <ExitWrapper onClick={() => {}}>
            <ExitToApp id={'exitBtn'} width={'35px'} color={'#fff'} />
        </ExitWrapper>
    )
}